export const antFilterFunc = (input: string, option: any) =>
  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;

export const antFilterGroupedFunc = (input: string, option: any) => {
  if (option.children) {
    return option.children.toLowerCase().startsWith(input.toLowerCase());
  }
  return false;
};
